export const Sexe = ['Homme', 'Femme'] as const

export type Sexe = (typeof Sexe)[number]

export const SexeLibelle: {
  [key in Sexe]: string
} = {
  Homme: 'Masculin',
  Femme: 'Féminin',
} as const
